import axios from 'axios';
import * as Config from '../../config';

const state = {};

const actions = {
    mercadoPagoCobros_connect({ commit, dispatch }, form) {

        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'mercado-pago-cobros/connect', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mercadoPagoCobros_getCliente({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'mercado-pago-cobros/get-cliente', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mercadoPagoCobros_getClientes({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'mercado-pago-cobros/get-clientes')
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mercadoPagoCobros_obtenerCobros({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'mercado-pago-cobros/obtener-cobros', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mercadoPagoCobros_getCiudades({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'mercado-pago-cobros/get-ciudades')
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mercadoPagoCobros_descargarQr({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'mercado-pago-cobros/descargar-qr', form, {
                responseType: 'blob'
            })
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mercadoPagoCobros_newInvoice({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'mercado-pago-cobros/new-invoice', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mercadoPagoCobros_switchAutomatico({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'mercado-pago-cobros/switch-automatico', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mercadoPagoCobros_getAutomatico({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'mercado-pago-cobros/get-automatico', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    mercadoPagoCobros_deleteCliente({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'mercado-pago-cobros/delete-cliente', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
}

const mutations = {

};

export default {
    state,
    actions,
    mutations
};